import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/mapTo'
import * as App from '../../app'
import * as Flash from '../../components/flash-message'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import * as Pager from '../../components/pager'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'

const blaclistFilterSelector: IsActive.FilterSelector = (state: ApplicationState) => state.excludedLists.view.filter
const refresh = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
) =>
  action$.ofType(Request.successConstant(Constants.ADD_EXCLUDED_LIST))
  .map(store.getState)
  .map((state) => Actions.fetchExcludedList(
    state.app.selectedCommunity,
    blaclistFilterSelector(state),
  ))

const navigateLoad = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.ADMIN_EXCLUDED_URL))
  .map(store.getState)
  .map((state) => Actions.fetchExcludedList(
    state.app.selectedCommunity,
    blaclistFilterSelector(state),
  ))

export const epic = ReduxObservable.combineEpics(
  navigateLoad,
  refresh,
  Flash.createFlashSuccessEpic(Constants.ADD_EXCLUDED_LIST, 'Excluded URL added'),
  IsActive.createFilterAddedEpic(Constants.ADD_EXCLUDED_LIST, Actions.fetchExcludedList, blaclistFilterSelector),
  IsActive.createFilterChangeEpic(Constants.FETCH_EXCLUDED_LIST, Actions.fetchExcludedList, blaclistFilterSelector),
  IsActive.createStatusUpdateEpic(Constants.UPDATE_BLACKLIST, Actions.updateStatus),
  Pager.pageChangeEpic(Constants.FETCH_EXCLUDED_LIST),
)



// WEBPACK FOOTER //
// ./src/pages/blacklists/epic.ts